import { render, staticRenderFns } from "./ChangeTwoFactorAuthenticationForm.vue?vue&type=template&id=c369144e&"
import script from "./ChangeTwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
export * from "./ChangeTwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTwoFactorAuthenticationForm.vue?vue&type=style&index=0&id=c369144e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports